import { BaseModel } from 'sjs-base-model';
import UrlModel from './UrlModel';
import AssetsModel from './Assets';

export default class HandshakeModel extends BaseModel {
    public readonly id: string = '';
    public readonly logo: string = '';
    public readonly name: string = '';
    public readonly loginUrls: UrlModel | undefined;
    public readonly challengeUrls: UrlModel | undefined;
    public readonly assets: AssetsModel | undefined;

    constructor(data: Partial<HandshakeModel>) {
        super();
        this.update(data);
    }
}
